import { render, staticRenderFns } from "./InvoicesReceivable.vue?vue&type=template&id=d0b8db42&scoped=true"
import script from "./InvoicesReceivable.vue?vue&type=script&lang=js"
export * from "./InvoicesReceivable.vue?vue&type=script&lang=js"
import style0 from "./InvoicesReceivable.vue?vue&type=style&index=0&id=d0b8db42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0b8db42",
  null
  
)

export default component.exports